import { t } from "i18next";
import React, { lazy, Suspense } from "react";

const RemoteBlogOverview = lazy(() => import("@/cms/components/BlogPages/components/BlogOverview"));

const BlogOverview = () => {
  return (
    <Suspense>
      <RemoteBlogOverview t={t} />
    </Suspense>
  );
};

export default BlogOverview;
